export const utilConsts = {
    TOGGLE_LEFT_SIDE_MENU: "TOGGLE_LEFT_SIDE_MENU",
    START_LOADING: "START_LOADING",
    END_LOADING: "END_LOADING",
    SET_REDIRECTION_STATE: "SET_REDIRECTION_STATE",
};